import React, { useState } from "react";
import "./style.css";
import "@fontsource-variable/open-sans";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export const DisplayTable = (props) => {
  let isu90Counter = props.isu90Counter;
  let flatPalletCounter = props.flatPalletCounter;
  let cPalletCounter = props.cPalletCounter;
  let pallet80x120Counter = props.pallet80x120Counter;
  let pallet100x120Counter =props.pallet100x120Counter;
  let NFEVpalletCounter= props.NFEVpalletCounter;
  let palletTotals = props.palletTotals;
  let jobNumber= Math.floor(100000 + Math.random() * 900000);
  let listNumber=1;

  const columns = [
    { id: "job", label: "Job" },
    { id: "list", label: "List" },
    { id: "isu90Count", label: "ISU-90" },
    { id: "flatPalletCount", label: "463L Pallet" },
    { id: "cPalletCount", label: "Classified 463L Pallet" },
    { id: "pallet80x120Counter", label: "80x120cm Pallet" },
    { id: "pallet100x120Counter", label: "100x120cm Pallet" },
    { id: "NFEVpalletCounter", label:"NFEV Pallet"},
    { id: "palletTotals", label: "Total" },
  ];

  const filteredColumns = columns.filter((column) => {
    if (column.id === "job" || column.id === "list" || column.id === "palletTotals") {
      // Always include "job" and "list" columns
      return true;
    }
    if (column.id === "isu90Count" && isu90Counter!==0){
      return true;
    }
    if (column.id === "cPalletCount" && cPalletCounter!==0){
      return true;
    }
    if (column.id === "flatPalletCount" && flatPalletCounter!==0){
      return true;
    }
    if (column.id === "NFEVpalletCounter" && NFEVpalletCounter!==0){
      return true;
    }
    if (column.id === "pallet80x120Counter" && pallet80x120Counter!==0){
      return true;
    }
    if (column.id === "pallet100x120Counter" && pallet100x120Counter!==0){
      return true;
    }

    
  });

  const newRow = {
    job: jobNumber,
    list: listNumber,
    ...(isu90Counter !== 0 && { isu90Count: isu90Counter }),
    ...(flatPalletCounter !== 0 && { flatPalletCount: flatPalletCounter }),
    ...(cPalletCounter !== 0 && { cPalletCount: cPalletCounter }),
    ...(pallet80x120Counter !== 0 && { pallet80x120Counter: pallet80x120Counter }),
    ...(pallet100x120Counter !== 0 && { pallet100x120Counter: pallet100x120Counter }),
    ...(NFEVpalletCounter !== 0 && { NFEVpalletCounter:NFEVpalletCounter}),
    palletTotals: palletTotals
  };
  let rows = [newRow];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f0f4f8",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#fbfcfe",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 1,
      borderColor: "#cdd7e1",
    },
  }));

  return (
    <div className="displayTable">
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer
          sx={{ maxHeight: 370, width: "100%", display: "flex" }}
          component={Paper}
        >
          <Table stickyHeader aria-label="customized table" width="100%">
            {/* Table Header */}
            <TableHead>
              <TableRow>
                {filteredColumns.map((column) => (
                  <StyledTableCell
                    key={column.id}
                    align="center"
                    width={`${100 / filteredColumns.length}%`}
                  >
                    {column.label}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              {rows.map((row, index) => (
                <StyledTableRow key={index}>
                  {filteredColumns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align="center"
                      width={`${100 / filteredColumns.length}%`}
                    >
                      {row[column.id]}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};
export default DisplayTable;
